import React, {useState} from 'react';
import {
    Container,
    Grid,
    Button,
    Paper,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
    Box,
    TablePagination, Typography
} from "@mui/material";
import {APP_STATUS, APP_STATUS_VERBOSE} from "../../../utils/constants";
import AddIcon from "@material-ui/icons/Add";

const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: theme.spacing(4),
    },
    addButton: {
        marginBottom: theme.spacing(2),
        background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
        color: '#fff',
        '&:hover': {
            background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
        },
    },
    tableRoot: {
        width: '100%',
        borderCollapse: 'separate',
        borderSpacing: '0px',
    },
    tableHeaderCell: {
        fontSize: '17px',
        fontWeight: 500,
    },
    tableCell: {
        color: '#ED6628',
    },
    actionButton: {
        background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
        color: '#fff',
        borderRadius: '20px',
        fontSize: '13px',
        padding: '6px 12px',
        minWidth: '180px',
        marginRight: theme.spacing(1),
        '&:hover': {
            background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",        },

    },
    title: {
        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
        color: 'transparent',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: '500 !important',
        textAlign: 'center',
        fontSize: '45px !important',
    },
    searchContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    searchInput: {
        marginLeft: theme.spacing(1),
        width: '300px',
    },

}));

const RatedProgramsDQAssessmentList = ({ data, actions, options }) => {
    const classes = useStyles();
    const { ratingPrograms } = data;
    const { accessAssessmentAction, createAssessmentAction } = actions;
    const { } = options;

    const [searchText, setSearchText] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const handleCreateAssessment = () => {
        if (createAssessmentAction) {
            createAssessmentAction();
        }
    };

    const handleAccessAssessment = (programId, program_state) => {
        if (accessAssessmentAction) {
            accessAssessmentAction(programId, program_state);
        }
    };

    const handleSearchChange = (event) => {
        setSearchText(event.target.value);
        setPage(0); // Reset to first page when search changes
    };

    const handleSearchClear = () => {
        setSearchText('');
        setPage(0);
    };

    const escapeRegExp = (value) => {
        return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    };

    const filteredPrograms = ratingPrograms.filter((program) => {
        const regex = new RegExp(escapeRegExp(searchText), 'i');
        return (
            regex.test(program.application_id) ||
            regex.test(program.programInfo ? program.programInfo.program_name : '') ||
            regex.test(program.app_status_v3)
        );
    });

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const date_options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

    return (
        <Container className={classes.container} maxWidth={false}>
            <Typography variant="h3" sx={{ textAlign: "center", marginBottom: 4, marginTop:{xs:'55px', sm:'40px'} }} className={classes.title}>
                Your DQ Assessments
            </Typography>
            <Typography
                variant="body1"
                sx={{
                    fontSize: "1.2rem",
                    textAlign: "center",
                    marginBottom: 4,
                    maxWidth: "100%",
                    color: "#474747",
                }}
            >
                The following is a list of your programs that you can add or have added an assessment to. In order to add an assessment to your program, click Add Assessment.
            </Typography>
            {/*<Box display={'flex'} alignItems="center"  mb={2} sx={{justifyContent:{sm:"flex-end", xs:'center'}}}>*/}
            {/*    <Button*/}
            {/*        startIcon={<AddIcon />}*/}
            {/*        variant="contained"*/}
            {/*        color="primary"*/}
            {/*        className={classes.addButton}*/}
            {/*        onClick={handleCreateAssessment}*/}
            {/*    >*/}
            {/*        ADD ASSESSMENT*/}
            {/*    </Button>*/}
            {/*</Box>*/}
            <TableContainer component={Paper} style={{backgroundColor:'#fff'}}>
                <Table className={classes.tableRoot} aria-label="programs table">
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.tableHeaderCell} align="center">Program ID</TableCell>
                            <TableCell className={classes.tableHeaderCell} align="center">Program Title</TableCell>
                            <TableCell className={classes.tableHeaderCell} align="center">Submission Date</TableCell>
                            {/*<TableCell className={classes.tableHeaderCell}>Package</TableCell>*/}
                            <TableCell className={classes.tableHeaderCell} align="center">Status</TableCell>
                            <TableCell className={classes.tableHeaderCell} align="center">Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredPrograms.length > 0 ? (
                            filteredPrograms
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((program) => (
                                    <TableRow key={program.application_id}>
                                        <TableCell className={classes.tableCell} align="center">{program.application_id}</TableCell>
                                        <TableCell className={classes.tableCell} align="center">{program.programInfo ? program.programInfo.program_name : ''}</TableCell>
                                        <TableCell className={classes.tableCell} align="center">
                                            {(new Date(program.submission_time)).toLocaleDateString(undefined, date_options)}
                                        </TableCell>
                                        {/*<TableCell className={classes.tableCell}>{program.package}</TableCell>*/}
                                        <TableCell className={classes.tableCell} align="center">
                                            {
                                                program.app_status === APP_STATUS.WITHDRAWN ||
                                                program.app_status === APP_STATUS.REJECTED ||
                                                program.app_status === APP_STATUS.HALTED_COLLECT_DATA ||
                                                program.app_status === APP_STATUS.HALTED_PROCESS_DATA ||
                                                program.app_status === APP_STATUS.HALTED_REPORT
                                                    ? APP_STATUS_VERBOSE[APP_STATUS.PROGRAM_SUMMARY_REPORT_HALTED]
                                                    : APP_STATUS_VERBOSE[program.app_status]
                                            }
                                        </TableCell>
                                        <TableCell className={classes.tableCell} align="center">
                                            <Box display="flex" gap={2} style={{alignItems:'center',justifyContent:'center'}}>
                                                <Button
                                                    className={classes.actionButton}
                                                    variant="contained"
                                                    color="secondary"
                                                    disabled={program.app_status_v3 < APP_STATUS.PROGRAM_FULL_REPORT_COMPLETED}
                                                    onClick={() => handleAccessAssessment(program.application_id, program.app_status)}
                                                >
                                                    {
                                                        program.app_status >= APP_STATUS.ASSESSMENTS_READY ? 'Access Assessment' :
                                                            program.app_status < APP_STATUS.ASSESSMENTS_READY ? 'Add Assessment' : ''
                                                    }
                                                </Button>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={6} align="center">
                                    No programs found.
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredPrograms.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Container>
    );
};

export default RatedProgramsDQAssessmentList;